import Swiper from 'swiper/bundle';

class Hero {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    const heroElement = document.querySelector('.hero-container');
    const swiperPagination = window.isTouchDevice ? false : { el: ".swiper-pagination", clickable: false, renderBullet: function (index, className) { return '<span data-index="' + (index) + '" class="' + className + '">' + (index + 1) + "</span>"; } }
  
    const heroSlidesTotal = heroElement.querySelectorAll('.swiper-slide').length; 
    function getRandomInt(max) {
      return Math.floor((Math.random()) * max);
    }

    let randomIndex = getRandomInt(heroSlidesTotal);

    const heroSwiper = new Swiper('.hero-container', {
      effect: 'fade',
      speed: window.isTouchDevice ? 400 : 100,
      slidesPerView: 1,
      // autoplay: window.isTouchDevice ? { delay: 3000 } : false,
      loop: window.isTouchDevice ? true : false,
      // cssMode: window.isTouchDevice ? true : false,
      waitForTransition: true,
      simulateTouch: false,
      pagination: swiperPagination,
      allowTouchMove: window.isTouchDevice ? true : false,
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
      on: {
        init: function (swiper) {
          if (window.isTouchDevice) {
            swiper.slideTo(randomIndex, 0);
          }
        },
        slideChange: function (swiper) {
          let currentIndex = swiper.activeIndex;
          let currentSlide = heroElement.querySelector('[data-real-index="' + (currentIndex + 1) + '"]');
          heroElement.querySelectorAll('.swiper-slide').forEach(slide => {
            if (slide.querySelector('video')) {
                slide.querySelector('video').pause();
                slide.querySelector('video').classList.remove('js-autoplay');
            }
          });
          if (currentSlide && currentSlide.querySelector('.js-to-play')) {
            currentSlide.querySelector('.js-to-play').play();
            currentSlide.querySelector('.js-to-play').classList.add('js-autoplay');
          }
        },
        touchMove: function (swiper) {

        },
      }
    });

    // window.addEventListener('load', function() {
      heroElement.querySelectorAll('.swiper-pagination-bullet').forEach((bullet) => {
        bullet.addEventListener('mouseover', () => {
          heroSwiper.slideTo(bullet.getAttribute('data-index'));
        });
      });

      // let touchstartX = 0;
      // let touchstartY = 0;
      // let touchendX = 0;
      // let touchendY = 0;


      // heroElement.addEventListener('touchstart', function(event) {
      //     touchstartX = event.changedTouches[0].screenX;
      //     touchstartY = event.changedTouches[0].screenY;
      // }, false);

      // heroElement.addEventListener('touchend', function(event) {
      //     touchendX = event.changedTouches[0].screenX;
      //     touchendY = event.changedTouches[0].screenY;
      //     handleGesture();
      // }, false); 

      // function handleGesture() {
      //     if (touchendX < touchstartX - 30) {
      //         console.log('Swiped left', touchstartY);
      //         heroSwiper.slideNext();
      //     }
          
      //     if (touchendX > touchstartX + 30) {
      //         console.log('Swiped right', touchstartY);
      //         heroSwiper.slidePrev();
      //     }
          
      //     if (touchendY < touchstartY) {
      //         console.log('Swiped up');
      //     }
          
      //     if (touchendY > touchstartY) {
      //       console.log('Swiped down');
      //     }
          
      //     if (touchendY === touchstartY) {
      //       console.log('Tap');
      //     }
      // }

     
    // });
  }

  bindEvents() {
   
  }
}

export default Hero;